import React from 'react';
import FraudCaseArchiveDetailSection from '../../../sections/AdminDashboard/SecurityFraud/FraudCaseArchiveDetail';

const FraudCaseArchiveDetail = () => {
  return <FraudCaseArchiveDetailSection />;
};

export default FraudCaseArchiveDetail;
